<div mat-dialog-title style="margin:0px;">Archive Report</div> 

    
    <mat-dialog-content>
        <div style="padding: 10px;">
                Are you sure you want to archive the report <b>{{reportName}}</b>?
                <br />
                If you continue, the report will be archived to your selected destination(s) once the report is through being processed.
        </div>

    </mat-dialog-content>
    
    <mat-dialog-actions>
        <div class="flex-footer-right">
            <tyl-button id="okButton" image="next arrow.png" label="Continue" (clickEvent)="okClick()"></tyl-button>
            <tyl-button id="cancelButton" image="cancel.png" label="Cancel" (clickEvent)="cancelClick()"></tyl-button>
        </div>
    </mat-dialog-actions>